import { initIntersectionObserver } from "@plugins";

const compareSidesHeights = document.querySelector(".js-compare-sides-heights");

if (!window.mobileMedia && compareSidesHeights) {
    initIntersectionObserver(compareSidesHeights, setPositionSticky);
}

function setPositionSticky(trigger) {
    if (trigger.children[1].offsetHeight < trigger.children[0].offsetHeight) {
        trigger.children[1].style.position = "sticky";
        trigger.children[1].style.top = "25px";
    }
}
